/* eslint react/prop-types: off */
import React from 'react'
import { FormInput, FormInputText } from 'camino-react'
import Select from 'react-select'

const SurveyScoreCondition = ({
  update,
  predicates: {
    survey_id: surveyID,
    comparision_type: comparisionType,
    comparision_score: comparisionScore
  },
  options: { surveys }
}) => {
  const comparisionOptions = [
    { value: 'above', label: 'Above' },
    { value: 'below', label: 'Below' }
  ]

  return (
    <div className="flex flex-col mb-10">
      <FormInput label="Survey">
        <Select
          options={surveys}
          value={surveyID}
          onChange={e => update('survey_id', e.value)}
        />
      </FormInput>

      <div className="flex w-full">
        <div className="w-1/2 mr-10">
          <FormInput label="Score is">
            <Select
              options={comparisionOptions}
              value={comparisionType}
              onChange={e => update('comparision_type', e.value)}
            />
          </FormInput>
        </div>

        <div className="w-1/2 text-2xl mt-1">
          <FormInput label="Score">
            <FormInputText
              value={comparisionScore}
              type="number"
              onValue={e => update('comparision_score', e)}
            />
          </FormInput>
        </div>
      </div>
    </div>
  )
}

export default SurveyScoreCondition
